<!-- components/GlobalLoading.vue -->
<template>
  <Teleport to="body">
    <a-spin v-show="getSpinLoading"
            class="global-spin-loading"
            size="large" />
  </Teleport>
</template>

<script setup>
import { computed } from 'vue';
import { useCommonStore } from '@/store/common.js';

const getSpinLoading = computed(() => useCommonStore().getSpinLoading);
</script>

<style scoped>
.global-spin-loading {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>